module.exports = __webpack_public_path__ + "static/category_vueminder_options-3f0d6d3513b64322828193dbd47b3f0e.png";